<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        

        <!-- SIDEBAR -->
        <SidebarBody/>

        

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody/>
            
            

            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" >

                <div class="row mb-32 gy-8 dash-top">

                    <div class="col-12" style="padding-left: 5px; padding-right: 5px;">

                        
                        <div class="row g-32">

                            

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -70px;"></h2>
                                
                                

                                <div class="row g-32">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-body">
                                                <h3 style="text-align: center;" class="mm-none">Activity Monitor</h3>
                                                <p class="hp-p1-body"></p>

                                                <div class="divider mt-18 mb-16 mm-none"></div>

                                                <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column;" id="emptyActivity">
                                                    <p class="hp-badge-text">No data yet...</p>
                                                </div>

                                                <div class="col-12" id="fullActivity">
                                        <div class="rounded-top border-start border-end border-top border-black-40 hp-border-color-dark-80">
                                            <div class="table-responsive">
                                                <table class="table mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-start">IP Addeess</th>
                                                            <th class="text-center">Date & Time</th>
                                                            
                                                            <th class="text-end">Location</th>
                                                        </tr>
                                                    </thead>

                                                    

                                                    <tbody>

                                                        

                                                        <tr v-for="activity in activityList" :key="activity.date">
                                                            <td class="align-middle text-start" >
                                                                <span class="hp-p1-body text-black-100 hp-text-color-dark-0 fw-lighter">{{ activity.ip }}</span>
                                                            </td>

                                                            <td class="align-middle text-center" >
                                                                <span class="hp-p1-body text-black-100 hp-text-color-dark-0 fw-lighter">{{ this.getDate(activity.date) }}</span>
                                                            </td>

                                                            <td class="align-middle text-end" >
                                                                <span class="hp-p1-body text-black-100 hp-text-color-dark-0 fw-lighter">{{ activity.country }}, {{ activity.city }}</span>
                                                            </td>

                                                            
                                                        </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                                <div class="mb-24" style="margin-top: 550px;">

                                                        

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SETTINGS -->
                            <SettingsBody/>
                            

                        </div>

                    </div>

                    
                </div>

                 <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import SettingsBody from '@/components/SettingsBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter } from "firebase/firestore"; 
    import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
    import {getAuth, onAuthStateChanged, signOut} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            SettingsBody,
            HeaderBody,
            FooterBody,
        },

        data(){
            return{
                loadingText:"",
                errorText: "",
                successText: "",

                activityList:[],

                
            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Activity Monitor';

            
            document.getElementById("moreN").classList.add("active");
            document.getElementById("moreN2").classList.add("active");

            this.getUserInfo();
            
            
        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            async getUserInfo(){

                this.loadingText = "Getting user info...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const querySnapshot = await getDocs(collection(db, "UserIpAddress", auth.currentUser.uid, "IpAddress"), orderBy("date", "desc"), limit(15));
                querySnapshot.forEach((doc) => {
                    this.activityList.push({
                        ip: doc.data().ip,
                        country: doc.data().country,
                        date: doc.data().date,
                        city: doc.data().city
                    });
                });

                if(this.activityList.length > 0){
                    document.getElementById("emptyActivity").style.display = 'none';
                    document.getElementById("fullActivity").style.display = 'block';
                    this.activityList.reverse();
                }
                else{
                    document.getElementById("emptyActivity").style.display = 'flex';
                    document.getElementById("fullActivity").style.display = 'none';
                }
                this.$refs.loadingModal.classList.remove("bg-active");

            },

            getDate(number){

                let date = String(new Date(number));
                let dateD = date.slice(0, -27);
                return dateD;

            }

        }
        
    }

</script>